import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const AdminRoute = () => {
    const { user, isLoading, isAuthenticated } = useAuth();
    const location = useLocation();

    // Wait for both auth check and user data to load
    if (isLoading || (isAuthenticated && !user)) {
        return null; // or a loading spinner
    }

    if (!user?.isAdmin) {
        return <Navigate to="/chats" state={{ from: location }} replace />;
    }

    return <Outlet />;
};

export default AdminRoute;
